<div class="suggestions-dropdown" *ngIf="isVisible" role="listbox" aria-label="Address suggestions">
  <div class="suggestions-loading" *ngIf="isLoading">
    <span class="suggestions-loading__spinner"></span>
    <span class="suggestions-loading__text">Searching...</span>
  </div>

  <ul class="suggestions-list" *ngIf="!isLoading && suggestions.length > 0">
    <li
      *ngFor="let suggestion of suggestions; let i = index; trackBy: trackBySuggestion"
      class="suggestions-item"
      [class.suggestions-item--active]="i === activeIndex"
      role="option"
      [attr.aria-selected]="i === activeIndex"
      (mousedown)="selectSuggestion(suggestion)"
      (mouseenter)="onMouseEnter(i)">
      <i class="suggestions-item__icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 32" width="24" height="32" fill="currentColor">
          <path d="M12 0c-6.62 0-12 5.284-12 11.78 0 1.692 0.354 3.312 1.048 4.812 3 6.442 8.756 13.25 10.448 15.18 0.123 0.142 0.304 0.232 0.506 0.232s0.383-0.090 0.505-0.231l0.001-0.001c1.688-1.93 7.442-8.736 10.44-15.18 0.7-1.5 1.052-3.12 1.052-4.812 0-6.496-5.384-11.78-12-11.78zM12 17.9c-3.436 0-6.234-2.748-6.234-6.12 0-3.376 2.798-6.118 6.232-6.118 3.44 0 6.234 2.74 6.234 6.12 0 3.37-2.796 6.116-6.234 6.116z"/>
        </svg>
      </i>
      <span class="suggestions-item__text">
        <ng-container *ngFor="let segment of highlightedSegmentsMap[i]">
          <strong *ngIf="segment.isMatch">{{ segment.text }}</strong>
          <ng-container *ngIf="!segment.isMatch">{{ segment.text }}</ng-container>
        </ng-container>
      </span>
    </li>
  </ul>

  <div class="suggestions-empty" *ngIf="!isLoading && suggestions.length === 0">
    <span>No addresses found</span>
  </div>
</div>
